import type { PageHelp } from '../network-help.data';

export const L10N_tr_g2: Record<string, PageHelp> = {
  'agency-onboarding': {
    title: 'Acente kaydını başlat',
    tag: 'Sihirbaz',
    tagline: 'Yeni bir seyahat işletmesini uyumlu biçimde ağa dahil etme.',
    business: {
      lead: 'Kayıt süreci, ağa açılan kontrollü ön kapıdır. Yeni bir acente para hareketi yapmadan veya bilet düzenlemeden önce, platformun onların kim olduğunu bilmesi, doğrulaması ve ticari koşullar üzerinde anlaşması gerekir — bu ilişki işte burada kurulur.',
      points: [
        { title: 'Ticaretten önce uyumluluk', desc: 'Platform yeni bir karşı tarafa kredi ve takas imkânı tanıdığı için kimlik ve finansal (KYC) kontrolleri en başta yapılır.' },
        { title: 'Koşullar ilişkiyi belirler', desc: 'Kademe, kâr marjı profili ve ürün erişimi burada kararlaştırılır — acentenin ilk günden itibaren nasıl ticaret yapacağını bunlar tanımlar.' },
        { title: 'İlk satışa hızlı ulaşım', desc: 'Temiz bir kayıt süreci, gelir üreten bir ortağı kayıt SLA’sı içinde canlıya alır.' },
      ],
    },
    software: {
      lead: 'Acente kaydını oluşturan ve onay için yönlendiren, adım adım yönlendirmeli bir form.',
      points: [
        { title: 'Kaydı adım adım tamamla', desc: 'Şirket → iletişim kişileri → KYC belgeleri → finansal kurulum → ürünler ve erişim → kademe ve kâr marjı → inceleme.' },
        { title: 'Kuyruğa gönder', desc: 'Sihirbazın tamamlanması, başvuruyu hemen canlıya almak yerine KYC inceleme kuyruğuna kaydeder.' },
        { title: 'Her şey tek yerde', desc: 'İletişim kişileri, belgeler ve ticari koşullar bir arada toplanır, böylece inceleyenler resmin tamamını görür.' },
      ],
    },
    related: ['agency-kyc', 'contract-templates', 'agencies'],
  },

  'agency-kyc': {
    title: 'KYC inceleme kuyruğu',
    tag: 'Uyumluluk',
    tagline: 'Her yeni acentenin ticaret yapmadan önce geçtiği kapı.',
    business: {
      lead: 'KYC — Müşterini Tanı — bir işletmenin platformda para işlemesine izin vermeden önce kimliğini doğrulama yükümlülüğüdür. Bu kuyruk, ağı dolandırıcılık ve batık borç riskinden koruyan denetim noktasıdır.',
      points: [
        { title: 'Bir gereklilik, formalite değil', desc: 'Platform, cüzdan veya kredi tanımlamadan önce karşı tarafları doğrulamak zorundadır.' },
        { title: 'Risk, görünür kılınmış', desc: 'Her başvuru bir risk sinyali taşır, böylece inceleyenler zamanlarını riskin en yüksek olduğu yere ayırır.' },
        { title: 'SLA bir sözdür', desc: 'Başvuruları hızlıca sonuçlandırmak, kontrolü atlamadan kayıt sürecini hızlı tutar.' },
      ],
    },
    software: {
      lead: 'Onaylamak veya reddetmek için belge süreci bulunan, bekleyen başvurulardan oluşan bir triyaj kuyruğu.',
      points: [
        { title: 'Kuyruğu işle', desc: 'Başvurular aşamalarıyla birlikte listelenir; gönderilen belgeleri incelemek için birini aç.' },
        { title: 'Süreci takip et', desc: 'Aşamalı bir ilerleme görünümü, her başvurunun nerede olduğunu ve karara kalan adımları gösterir.' },
        { title: 'Karar ver', desc: 'Acenteyi canlı ticarete açmak için onayla (ana sözleşmesini otomatik üreterek) veya bir gerekçeyle reddet.' },
      ],
    },
    related: ['agency-onboarding', 'contract-templates', 'agencies'],
  },

  'agency-profile': {
    title: 'Acente profili',
    tag: 'Kayıt',
    tagline: 'Tek bir acentenin tüm ticari ve uyumluluk ilişkisi.',
    business: {
      lead: 'Profil, bir ticaret ilişkisinin tam resmidir — durumu, parası ve işlediği koşullar. Belirli bir acentenin platformla nasıl iş yaptığını anlamak veya ayarlamak için açtığınız yer burasıdır.',
      points: [
        { title: 'Koşullar burada yaşar', desc: 'Kademe, kâr marjı devralımı ve ürün erişimi bu acentenin ekonomisini tanımlar ve bu kayıt üzerinden yönetilir.' },
        { title: 'Bir bakışta durum', desc: 'Cüzdan, kredi ve KYC durumu, acentenin şu anda ticaret yapıp yapamayacağını anında söyler.' },
        { title: 'Devral veya geçersiz kıl', desc: 'Bir acente kademesinin varsayılanlarını takip edebilir veya yalnızca kendisi için müzakere edilmiş özel geçersiz kılmalar taşıyabilir.' },
      ],
    },
    software: {
      lead: 'Kimlik, para ve yapılandırmayı tek bir görünümde bir araya getiren acente bazlı bir detay yüzeyi.',
      points: [
        { title: 'Varlıkları ve erişimi yönet', desc: 'Bu acenteye ait SIGN’lar, satış kanalları, şubeler, roller ve ürün erişimi buradan ulaşılabilir.' },
        { title: 'Grup üyelikleri', desc: 'Acentenin fiyatlandırma grubu üyelikleri bir etiket şeridi olarak görünür ve Grup kapsamlı kurallara girdi sağlar.' },
        { title: 'Kendi görünümü vs yönetici görünümü', desc: 'Bir acente kendi profilini çoğunlukla salt okunur görür; bir yönetici koşulları düzenleyebilir ve işlem yapabilir.' },
      ],
    },
    related: ['agencies', 'markup', 'branches', 'signs'],
  },

  'contract-templates': {
    title: 'Sözleşme şablonları',
    tag: 'Anlaşmalar',
    tagline: 'Ana sözleşmenin üretildiği koşul şablonları.',
    business: {
      lead: 'Her acente bir ana sözleşme kapsamında ticaret yapar. Sözleşme şablonları, bu anlaşmaların üretildiği sürümlenmiş koşullardır — böylece hukuki ilişki tüm ağ genelinde tutarlı, güncel ve denetlenebilir olur.',
      points: [
        { title: 'Tek koşul kaynağı', desc: 'Bir acentenin sözleşmesinin üretilmesi bu katalogdan beslenir, böylece herkes aynı ve güncel koşulları imzalar.' },
        { title: 'Sürümlenmiş ve denetlenebilir', desc: 'Yeni sürümler eskilerin yerini alır; emekliye ayrılmış sürümler, eski sözleşmeleri yenilemek için erişilebilir kalır.' },
        { title: 'Yaşam döngüsünü besler', desc: 'Bir şablon, üret → gönder → imzala → karşı imzala → aktif anlaşma akışının girdisidir.' },
      ],
    },
    software: {
      lead: 'Üretim formunun okuduğu şablon sürümleri kataloğu.',
      points: [
        { title: 'Bir sürüm ekle', desc: 'Yeni bir şablon sürümü oluştur ve kaynak belgesini yükle.' },
        { title: 'Sil değil, emekliye ayır', desc: 'Yerini alan sürümleri emekliye ayır; bunlar zaten üzerinde bulunan sözleşmeler için çözümlenebilir kalır.' },
        { title: 'Seçici kaynağı', desc: 'Sözleşme üretim formunun şablon seçicisi bu katalogtan okur.' },
      ],
    },
    related: ['agency-onboarding', 'agency-kyc', 'agencies'],
  },

  // ── SYSTEM section ──────────────────────────────────────────────────────

  'reference-data': {
    title: 'Referans Verileri',
    tag: 'Ana sözlükler',
    tagline: 'Her rezervasyon, kupon ve fiyatın üzerine kurulduğu standart arama listeleri.',
    business: {
      lead: 'Referans verileri paylaşılan tek doğruluk kaynağıdır — havayolları, havaalanları, şehirler, para birimleri, oda tipleri, kabin sınıfları ve düzinelerce diğeri. Bunları bir kez normalleştirmek, arama sonuçlarının, biletlerin, kuponların ve fiyatlandırma kurallarının tüm tedarikçiler ve servisler arasında aynı dili konuşması anlamına gelir.',
      points: [
        { title: 'Platform genelinde tutarlılık', desc: 'Tek bir düzenlenmiş liste her servisi besler, böylece bir tedarikçinin kodları her yerde aynı standart girdiye eşlenir.' },
        { title: 'Bir kez değiştir, her yerde uygula', desc: 'Bir referans satırını düzenlemek onu arama, rezervasyon, belgeler ve raporlama için aynı anda günceller.' },
        { title: 'Yönetilen, serbest metin değil', desc: 'Kontrollü sözlükler, kirli verinin fiyatlandırma ve kanal eşlemesinden uzak durmasını sağlar.' },
      ],
    },
    software: {
      lead: 'Alanlara göre gruplanmış ~35 referans kategorisi üzerinde şema odaklı bir yönetim yüzeyi.',
      points: [
        { title: 'Kategoriye göre gözat ve düzenle', desc: 'Bir kategori seç, satırlarını ara ve girdileri ekle / düzenle / etkinleştir-devre dışı bırak; bazıları geçerlilik tarihlidir (para birimleri, vergiler, döviz kuru).' },
        { title: 'İnce ayarlı erişim', desc: 'Görüntüle / Ekle / Düzenle / Durum, Roller ve Erişim üzerinden her kategori için ayrı verilir — buradaki düğmeler rolünüzün izin verdiğini yansıtır.' },
        { title: 'Standart vs düzenlenebilir', desc: 'Birkaç liste (ülkeler, saat dilimleri) standarttır ve merkezi olarak yönetilir, gelişigüzel oluşturulmaz.' },
      ],
    },
    related: ['rbac', 'data-simulator'],
  },

  'data-simulator': {
    title: 'Veri Simülatörü',
    tag: 'Sentetik veri',
    tagline: 'Platformu gerçek siparişler olmadan çalıştırmak için gerçekçi rezervasyonlar üret.',
    business: {
      lead: 'Simülatör inandırıcı talep üretir — ürünler, acenteler ve tarihler arasında rezervasyonlar — böylece panolar, raporlar, fiyatlandırma ve takas, gerçek ticaretten önce veya onunla birlikte gösterilebilir ve stres testine tabi tutulabilir.',
      points: [
        { title: 'Platformu kanıtla', desc: 'Doldurulmuş bir sistem, raporlama ve para akışlarının hacimde nasıl davrandığını paydaşlara gösterir.' },
        { title: 'Geri almak güvenli', desc: 'Üretilen siparişler etiketlenir, böylece bütün bir parti temiz biçimde geri alınabilir.' },
        { title: 'Hedefli senaryolar', desc: 'İşin belirli bir dilimini modellemek için bir partiyi belirli acentelere veya ürünlere yönlendir.' },
      ],
    },
    software: {
      lead: 'Rezervasyon motoruna gerçek, etiketli siparişler enjekte eden bir parti üreteci.',
      points: [
        { title: 'Bir parti yapılandır', desc: 'Hacmi, ürün karışımını, acenteleri ve tarih aralığını seç, ardından yayınla.' },
        { title: 'Gerçek siparişler, işaretli', desc: 'Yayınlanan öğeler “simulated” etiketli gerçek booking-service siparişleridir, böylece Tüm Rezervasyonlar’da görünürler.' },
        { title: 'Tüm partiyi geri al', desc: 'Bir partiyi tek işlemle kaldırarak sistemi önceki durumuna döndür.' },
      ],
    },
    related: ['reference-data', 'rbac'],
  },

  rbac: {
    title: 'Roller ve Erişim',
    tag: 'RBAC',
    tagline: 'İnce ayarlı izinleri, kişilerinizin taşıdığı rollere birleştir.',
    business: {
      lead: 'Erişim, iş unvanlarıyla değil izinlerle yönetilir. Roller ve Erişim, atomik izin kodlarını rollere birleştirip verdiğiniz yerdir — böylece ister platform personeli ister acente kullanıcısı olsun, her kişi tam olarak yapması gerekeni yapar, fazlasını değil.',
      points: [
        { title: 'En az ayrıcalık', desc: 'Dar izinler vermek, bir hesap kötüye kullanıldığında etki alanını sınırlar.' },
        { title: 'İki kapsam', desc: 'Platform rolleri ağ genelinde işler; acente rolleri kendi kiracılarıyla sınırlıdır.' },
        { title: 'Kilitlenmeye karşı güvenli', desc: 'Mühürlü sistem rolleri (örn. Platform Yöneticisi) izinlerini kilitli tutar, böylece kimse kendi erişimini kaldıramaz.' },
      ],
    },
    software: {
      lead: 'Roller, Kullanıcılar ve canlı bir izin kataloğu tek yerde.',
      points: [
        { title: 'Bir rol oluştur', desc: 'Modüle göre gruplanmış izin kodlarını işaretle; bir rol, seçtiğiniz kümeden ibarettir.' },
        { title: 'Referans verileri matrisi', desc: 'Referans verileri izinleri kategori × eylem (Görüntüle/Ekle/Düzenle/Durum) bazında verilir; acente rolleri yalnızca Görüntüle alır.' },
        { title: 'Kullanıcılara ata', desc: 'Kullanıcılar sekmesi rolleri kişilere, platform veya belirli bir acente kapsamında iliştirir.' },
      ],
    },
    related: ['users', 'reference-data', 'settings'],
  },

  users: {
    title: 'Kullanıcılar',
    tag: 'Hesaplar',
    tagline: 'Oturum açabilen kişiler ve taşıdıkları roller.',
    business: {
      lead: 'Kullanıcılar platformu işleten bireylerdir — platform personeli ve acente personeli. Onları burada yönetmek, kimin erişimi olduğunu denetleme, kişiler geldikçe ve ayrıldıkça bunu güncel tutma ve her eylemi hesap verebilir bir hesaba bağlama biçiminizdir.',
      points: [
        { title: 'Erişim istihdamı takip eder', desc: 'Hesapları hızla tanımlamak ve devre dışı bırakmak güvenliğin ön cephesidir.' },
        { title: 'Gücü roller taşır', desc: 'Bir kullanıcı tek başına hiçbir şey yapmaz — ne yapabileceğine rolleri karar verir.' },
        { title: 'Hesap verebilirlik', desc: 'Eylemler adı belli bir hesaba atfedilebilir, ki bu denetim ve anlaşmazlıklar için önemlidir.' },
      ],
    },
    software: {
      lead: 'Rolleri ve durumlarıyla birlikte hesapların dizini.',
      points: [
        { title: 'Tanımla ve ata', desc: 'Bir kullanıcı oluştur ve platform veya bir acente kapsamında bir ya da daha fazla rol ata.' },
        { title: 'Etkinleştir / devre dışı bırak', desc: 'Biri ayrıldığında geçmişi silmeden erişimi kapat.' },
        { title: 'Kapsam duyarlı', desc: 'Yöneticiler tüm kullanıcıları yönetir; bir acente yöneticisi yalnızca kendi kişilerini yönetir.' },
      ],
    },
    related: ['rbac', 'settings'],
  },

  settings: {
    title: 'Ayarlar',
    tag: 'Yapılandırma',
    tagline: 'Platform ve acente düzeyindeki yapılandırma tek yerde.',
    business: {
      lead: 'Ayarlar, platformun nasıl sunulduğunu ve davrandığını şekillendiren düğmeleri barındırır — markalama, bildirimler, entegrasyonlar ve varsayılan yapılandırma. Bunları doğru ayarlamak deneyimi tutarlı ve altyapıyı bağlı tutar.',
      points: [
        { title: 'Kimlik ve deneyim', desc: 'Markalama ve varsayılanlar, konsolun kullanıcılarınız için nasıl göründüğünü ve davrandığını belirler.' },
        { title: 'Bağlı kal', desc: 'Entegrasyon ve bildirim ayarları, platformu dış dünyayla konuşur halde tutar.' },
        { title: 'Kapsamlı sahiplik', desc: 'Platform yöneticileri platform genelindeki ayarları yönetir; acente yöneticileri kendi kapsamlarını yönetir.' },
      ],
    },
    software: {
      lead: 'Markalama, bildirimler, entegrasyonlar ve acente varsayılanları için gruplanmış yapılandırma panelleri.',
      points: [
        { title: 'Bölüme göre düzenle', desc: 'Gruplanmış panelleri gez ve yönettiğiniz alanları kaydet.' },
        { title: 'İzin kontrollü', desc: 'Erişim, ayarları yönetme iznini gerektirir; kenar çubuğu girişi Sistem’in geri kalanıyla tutarlı kalır.' },
        { title: 'Platform vs acente', desc: 'Neyi değiştirebileceğiniz, platform mu yoksa acente kapsamına mı sahip olduğunuza bağlıdır.' },
      ],
    },
    related: ['rbac', 'users'],
  },

  issues: {
    title: 'Hata İzleyici',
    tag: 'Dahili KG',
    tagline: 'Ürün sorunlarını raporlamak ve triyaj etmek için dahili hata izleyici.',
    business: {
      lead: 'Hata İzleyici, konsolda bulunan sorunların yakalanma, triyaj edilme ve düzeltilme biçimidir — müşteri destek taleplerinden ayrı, özel bir mühendislik geri bildirim döngüsüdür, böylece acentelere gürültü ulaşmadan kalite artar.',
      points: [
        { title: 'Döngüyü kapat', desc: 'Bağlamlı yapılandırılmış bir rapor, “bozuk” ifadesini bir mühendisin üzerinde işlem yapabileceği bir şeye dönüştürür.' },
        { title: 'Müşteri desteği değil', desc: 'Bu dahili KG’dir — acenteye dönük Destek Talepleri’nden farklıdır.' },
        { title: 'Kanıt eklenmiş', desc: 'Ekran görüntüleri ve ortam bağlamı, sorunları yeniden üretilebilir kılar.' },
      ],
    },
    software: {
      lead: 'Anlık görüntüler ve durumla birlikte raporlanmış sorunların bir triyaj kuyruğu.',
      points: [
        { title: 'Her yerden raporla', desc: 'Raporlayıcı kısayolu ile her yerden bir sorun (anlık görüntüyle) yakala, ardından buradan takip et.' },
        { title: 'Triyaj ve durum', desc: 'Kuyruğu işle — sorunları ata, önceliklendir ve yaşam döngüleri boyunca ilerlet.' },
        { title: 'Geliştirici kapsamlı', desc: 'Tam triyaj Geliştirici rolüyle sınırlıdır, böylece İzleyici her yöneticinin görünümünü doldurmaz.' },
      ],
    },
    related: ['my-issues'],
  },

  'my-issues': {
    title: 'Raporladığım Hatalar',
    tag: 'Raporlarım',
    tagline: 'Bizzat açtığınız sorunlar ve her birinin durumu.',
    business: {
      lead: 'Bu, Hata İzleyici’nin kendi diliminizdir — açtığınız raporlar ve ilerlemeleri. Raporlayıcı için geri bildirim döngüsünü kapatır: açtığınız şeyin görüldüğünü ve ilerlediğini görebilirsiniz.',
      points: [
        { title: 'Raporlayıcılar için görünürlük', desc: 'Bir raporun alındığını ve ilerlediğini bilmek, kişileri sorunları bildirmeye devam etmeye teşvik eder.' },
        { title: 'Kendi bağlamınız', desc: 'Yalnızca açtığınız sorunlar, böylece liste kişisel olarak alakalı kalır.' },
        { title: 'Çözüme kadar takip et', desc: 'Her raporu açıktan çözüldüye kadar takip et.' },
      ],
    },
    software: {
      lead: 'Kendi raporlarınızla sınırlı, Hata İzleyici’nin filtrelenmiş bir görünümü.',
      points: [
        { title: 'Raporlarını gör', desc: 'Açtığınız her sorun, mevcut durumuyla birlikte.' },
        { title: 'Detay için aç', desc: 'İzini, anlık görüntüsünü ve güncellemelerini görmek için bir raporu aç.' },
        { title: 'Daha fazla aç', desc: 'Raporlayıcı kısayolundan yeni sorunlar aç; burada görünürler.' },
      ],
    },
    related: ['issues'],
  },

  // ── SUPPLY section ──────────────────────────────────────────────────────

  'supply-properties': {
    title: 'Otel tesisleri',
    tag: 'Kendi envanteriniz',
    tagline: 'Doğrudan sözleşmeli otellerinizin dizini — sahip olduğunuz ve kendiniz sattığınız odalar.',
    business: {
      lead: 'Bunlar, harici otel motorlarından yeniden sattığınız ücretlerin aksine, doğrudan sözleşme yaptığınız otellerdir. Envanter sizin olduğu için odaları, gecelik fiyatları ve müsaitliği siz belirlersiniz — ve bir yatak bankasının marjını değil, marjın tamamını siz tutarsınız.',
      points: [
        { title: 'Kendi vs yeniden satılan envanter', desc: 'Kendi tesisleriniz Ara ve Rezervasyon Yap içinde harici otel motoru sonuçlarının yanında yer alır; burada fiyatı ve müsaitliği baştan sona siz kontrol edersiniz.' },
        { title: 'Kapsam erişimi belirler', desc: 'Platform kapsamlı bir tesis, herhangi bir acentenin satabileceği paylaşılan envantere dönüşür; acente kapsamlı olan ise o acenteye özel kalır.' },
        { title: 'Bir bakışta satış modu', desc: 'Her tesis Anında (hemen onaylar) veya Talep Üzerine (operatörün onayladığı bir rezervasyon) olur — kart hangisi olduğunu işaretler.' },
      ],
    },
    software: {
      lead: 'Hızlı durumla birlikte tesislerinizin aranabilir, filtrelenebilir bir ızgarası.',
      points: [
        { title: 'Bir tesis bul', desc: 'Ada veya şehre göre ara ve kapsama, satış moduna veya duruma göre filtrele.' },
        { title: 'Yenisini kaydet', desc: 'Kayıt çekmecesi üzerinden sıfırdan oluştur veya bir referans otelden tohumla.' },
        { title: 'Yönetmek için aç', desc: 'Odalarını, ücretlerini, kontenjanını, yan hizmetlerini ve sözleşmesini yönetmek için tesis kaydına geç.' },
      ],
    },
    related: ['supply-property-detail', 'reference-data'],
  },

  'supply-property-detail': {
    title: 'Otel Tesisi',
    tag: 'Tesis kaydı',
    tagline: 'Bir tesisin tam kaydı — odalar, ücretler, müsaitlik, ekstralar ve arkasındaki sözleşme.',
    business: {
      lead: 'Bir otel tesisi, sahip olduğunuz ve doğrudan sattığınız bir envanter parçasıdır. Bir rezervasyonun ihtiyaç duyduğu her şey burada bulunur: hangi odaların var olduğu, her gece ne kadar ettikleri, kaç tanesinin müsait olduğu, hangi ekstraların eklenebileceği ve onu yöneten sözleşme. Bunu doğru yapın, tesis hem B2B konsolunuzda hem de B2C’de satışa hazır olur.',
      points: [
        { title: 'Kendi envanteriniz, kendi marjınız', desc: 'Kendiniz yüklediğiniz doğrudan bir sözleşme hiçbir yatak bankası kâr marjı taşımaz — net ve satış fiyatı arasındaki fark tamamen sizindir.' },
        { title: 'Platform vs acente kapsamı', desc: 'Platform kapsamı, tesisi acentelere paylaşılan envanter olarak yayınlar; acente kapsamı onu özel tutar. Platforma ait satırlar bir acente için salt okunurdur.' },
        { title: 'Anında vs Talep Üzerine', desc: 'Anında, kontenjana karşı hemen onaylar; Talep Üzerine, rezervasyonu operatörün bir SLA içinde onayladığı veya reddettiği bir talep olarak yakalar (ödeme yetkilendirilir, onayda tahsil edilir).' },
        { title: 'Müsaitlik sizi korur', desc: 'Kontenjan sözleşmeli oda sayısıdır; tutulan ve satılan odalar düşülür, böylece bir Anında satış asla fazla satış yapamaz.' },
      ],
    },
    software: {
      lead: 'Bir tesis için sekmeli bir çalışma alanı — her sekme kaydın bir bölümüdür ve ne kadar tuttuğunu gösteren bir rozet taşır. Aşağıda her sekmenin ne yaptığı ve öğelerinin nasıl çalıştığı yer alır.',
      points: [
        { title: 'Genel bakış', desc: 'Önce okunan özet: konum ve harita, yıldız derecesi, zincir, öne çıkan olanaklar, açıklama ve canlı KPI’lar — aya kadar doluluk, ADR ve RevPAR (tümü tesisin toplam oda envanterine göre hesaplanır).' },
        { title: 'Odalar ve oda tipleri', desc: 'Her oda tipini ekle / düzenle: Oda tipleri referansından standartlaştırılmış bir kategori seç (arama eşleşmesini ve kanal eşlemesini yürüten budur), müşteriye dönük bir görünen ad ve kısa kod, azami doluluk, m² cinsinden büyüklük ve toplam fiziksel envanter — sonuncusu Genel bakış’ın doluluk / RevPAR değerinin bölenidir.' },
        { title: 'Yataklar (oda tipi başına)', desc: 'Yatak düzeni serbest metin değil, bir düzenleyicidir: Yatak tipleri referansından alınan sayı × yatak tipi satırları (örn. “1 King + 1 Çekyat”). Oluşturulan dizge arama sonuçlarında ve kuponda görünen şeydir, böylece her yerde tutarlı kalır.' },
        { title: 'Olanaklar (oda ve tesis başına)', desc: 'Olanak kategorisine göre gruplanmış, referans destekli bir çoklu seçim (Referans verileri → Olanaklar altında yönetilir). Serbest metin yazmak yerine kontrollü listeden seç; seçimler görünen etiketler olarak saklanır, böylece B2B konsolunda, kuponda ve B2C’de aynı biçimde görüntülenir.' },
        { title: 'Galeri', desc: 'Tesis ve oda düzeyindeki fotoğrafları yükle ve sırala. Bunlar acentelerin Ara ve Rezervasyon Yap’ta gördüğü ve misafirlerin kuponda gördüğü görsellerdir; fotoğrafı olmayan bir oda tesis galerisine geri döner.' },
        { title: 'Ücret planları', desc: 'Bir ücret planı satılabilir bir pakettir — Sadece Oda, B&B, İade Edilemez vb. Her biri kendi fiyatlarını taşır ve tesisin satış modunu (Anında / Talep Üzerine) geçersiz kılabilir. Takvim ve arama fiyatları daima ücret planı başınadır.' },
        { title: 'Ücretler ve takvim', desc: 'Ücret planı başına, tek bir gece, bir tarih aralığı veya bütün bir sezon için net fiyatı tek işlemde belirle. Hafta sonu ve sezon tarihleri görsel ipuçları taşır (renkli bir etiket) ve satış durdurma, fiyatını silmeden bir tarihi kapatır. Kaydetmek için bir ücret değeri gereklidir — boş bir küme reddedilir.' },
        { title: 'Kontenjan ve tutmalar', desc: 'Gün başına müsait sözleşmeli oda sayısı. Izgara her günü tutulan (rezerve, ödemesi henüz tahsil edilmemiş), satılan (onaylı) ve satışa açık olarak ayırır; bir tarih aralığında bir sayıyı toplu güncelle. Anında satışlar bunu gerçek zamanlı düşürür; Talep Üzerine satışlar operatör onaylayana kadar buna dokunmaz.' },
        { title: 'Yan hizmetler', desc: 'Bu tesisin sattığı ekstralar — havaalanı transferi, kahvaltı, spa, geç çıkış — her biri Yan hizmet tipleri referansından bir fiyat ve bir ücretlendirme temeliyle (rezervasyon başına / gece başına / kişi başına) alınır. Bunlar bir rezervasyonun Ücretler’inde ek olarak görünür.' },
        { title: 'Canlı rezervasyonlar', desc: 'Bu tesise karşı yapılan her rezervasyon. Talep Üzerine konaklamalarda Onayla / Reddet çubuğu buradadır: Onayla yetkilendirilen ödemeyi tahsil eder ve kontenjanı taahhüt eder; Reddet yetkilendirmeyi iptal eder — ikisi de tesisin SLA penceresi içinde.' },
        { title: 'Sözleşme ve ayarlar', desc: 'Tedarikçi sözleşmesi artı operasyonel anahtarlar: satış modu (Anında veya SLA saatleri ve rezervasyon son gün süresiyle Talep Üzerine), platform vs acente kapsamı ve tesisin aktif durumu.' },
        { title: 'Kayıt, düzenleme ve toplu araçlar', desc: 'Yönlendirmeli bir kayıt çekmecesi sıfırdan veya bir referans otelden tohumlanmış bir tesis oluşturur; düzenleme çekmecesi çekirdek detayları sonradan ayarlar; toplu çekmeceler ücretleri veya kontenjanı birçok gün için bir kerede belirler.' },
      ],
    },
    modes: {
      lead: 'İki anahtar bir tesisin nasıl davrandığını değiştirir — satış modu (Sözleşme ve ayarlar altında belirlenir, ücret planı başına geçersiz kılınabilir) ve kapsam (tesis oluşturulurken belirlenir).',
      modes: [
        { name: 'Instant', when: 'güvendiğiniz canlı kontenjan', desc: 'Rezervasyon hemen onaylanır ve kontenjanı düşürür; ödeme anında tahsil edilir. Tarihler ve doluluk için boş oda olmadığında engellenir.' },
        { name: 'On-Request', when: 'otel onaylamalı', desc: 'Rezervasyon bir talep olarak alınır — ödeme yetkilendirilir (tahsil edilmez) ve kontenjana dokunulmaz — ve operatör SLA içinde onaylar veya reddeder. Onay ödemeyi tahsil eder ve kontenjanı taahhüt eder; reddetme yetkilendirmeyi iptal eder.' },
        { name: 'Platform kapsamı', when: 'paylaşılan envanter', desc: 'Tesis, satılabilir envanter olarak acentelere yayınlanır; onlar onu salt okunur görür ve kendi perakende kâr marjları altında yeniden satar.' },
        { name: 'Acente kapsamı', when: 'özel envanter', desc: 'Tesis tek bir acenteye aittir ve yalnızca onun tarafından satılabilir.' },
      ],
    },
    examples: [
      {
        title: 'Bir gece için müsaitlik (Instant satış modu)',
        rows: [
          { label: 'Sözleşmeli kontenjan', value: '10' },
          { label: '− Tutulan (tahsil bekliyor)', value: '3', accent: 'info' },
          { label: '− Satılan (onaylı)', value: '5' },
          { label: 'Satışa açık', value: '2', strong: true, accent: 'accent' },
        ],
        note: 'Talep Üzerine rezervasyonlar operatör onaylayana kadar kontenjan tüketmez — bunlar günlük sayıya değil, oda tipine göre kısıtlanır.',
      },
      {
        title: 'Ücretler ve takvim — 3 gecelik bir konaklama (Deluxe · B&B)',
        rows: [
          { label: 'Per 2 Nis · hafta içi net', value: '2,200,000' },
          { label: 'Cum 3 Nis · hafta sonu net', value: '2,600,000', accent: 'info' },
          { label: 'Cmt 4 Nis · hafta sonu net', value: '2,600,000', accent: 'info' },
          { label: 'Oda ara toplamı (3 gece)', value: '7,400,000', strong: true },
        ],
        note: 'Her gece, ücret planı için belirlenen net fiyatı taşır; hafta sonu/sezon ipuçları görsel yardımcılardır — fiyat, o tarih için ne belirlediyseniz odur. Satış durdurma gecesi, fiyatı ne olursa olsun rezerve edilemez.',
      },
      {
        title: 'O rezervasyondaki yan hizmetler (2 misafir, 3 gece)',
        rows: [
          { label: 'Oda ara toplamı', value: '7,400,000' },
          { label: '+ Kahvaltı · kişi başına / gece · 150,000 × 2 × 3', value: '+900,000', accent: 'success' },
          { label: '+ Havaalanı transferi · rezervasyon başına', value: '+1,200,000', accent: 'success' },
          { label: 'Tesis toplamı (kâr marjı öncesi)', value: '9,500,000', strong: true, accent: 'accent' },
        ],
        note: 'Her yan hizmetin ücretlendirme temeli (rezervasyon başına / gece başına / kişi başına) nasıl çarpılacağına karar verir. Ardından Kâr Marjı ve Kurallar’dan gelen perakende kâr marjı, yolcu fiyatına ulaşmak için üstüne uygulanır.',
      },
    ],
    tabs: {
      overview: {
        title: 'Genel bakış',
        lead: 'Tesisin önce okunan anlık görüntüsü — nerede olduğu, ne sunduğu ve şu anda nasıl performans gösterdiği.',
        points: [
          { title: 'Kimlik ve konum', desc: 'Ad, yıldız derecesi, zincir, adres ve harita işareti — bir rezervasyon yapanın önce kontrol ettiği gerçekler.' },
          { title: 'Öne çıkan olanaklar ve açıklama', desc: 'Tesisin satış noktaları, referans destekli olanaklardan ve serbest metin açıklamadan alınır.' },
          { title: 'Canlı KPI’lar', desc: 'Aya kadar doluluk, ADR (ortalama günlük ücret) ve RevPAR (müsait oda başına gelir) — tümü tesisin toplam oda envanterine göre hesaplanır, bu yüzden ancak her oda tipinin envanter sayısı ayarlandığında doğru okurlar.' },
        ],
        examples: [
          {
            title: 'KPI’lar nasıl hesaplanır — 40 oda, 30 günlük bir ay',
            rows: [
              { label: 'Müsait oda-geceleri (40 × 30)', value: '1,200' },
              { label: 'Satılan oda-geceleri', value: '900' },
              { label: 'Aya kadar doluluk (900 ÷ 1,200)', value: '75%', accent: 'info', strong: true },
              { label: 'Oda geliri', value: '90,000,000' },
              { label: 'ADR (gelir ÷ satılan 900)', value: '100,000' },
              { label: 'RevPAR (gelir ÷ müsait 1,200)', value: '75,000', accent: 'success', strong: true },
            ],
            note: 'RevPAR fiyat ile doluluğu harmanlar, bu yüzden ücret ya da doluluk oranı düşerse o da düşer. Bir oda tipinin envanter sayısının eksik olması böleni bozar — kutucuklar, Odalar sekmesinde ayarlanana kadar bir tire gösterir.',
          },
        ],
      },
      rooms: {
        title: 'Odalar ve oda tipleri',
        lead: 'Tesisin ne satabileceğini tanımla: her oda tipi, kaç kişilik olduğu ve ne kadarının var olduğu.',
        points: [
          { title: 'Normalleştirilmiş kategori', desc: 'Oda tipleri referansından standartlaştırılmış bir tip seç — arama eşleşmesini ve kanal eşlemesini yürüten budur, serbest metin adı değil.' },
          { title: 'Görünen ad ve kod', desc: 'Misafire dönük bir ad (“Deluxe Deniz Manzaralı”) ve operatör için kısa bir kod.' },
          { title: 'Yataklar — bir düzenleyici, serbest metin değil', desc: 'Yatak düzenini, Yatak tipleri referansından alınan sayı × Yatak tipi satırlarından (örn. “1 King + 1 Çekyat”) oluştur; oluşturulan dizge aramada ve kuponda görünen şeydir.' },
          { title: 'Olanaklar', desc: 'Kategoriye göre gruplanmış, referans destekli bir çoklu seçim — görünen etiketler olarak saklanır, böylece B2B’de, kuponda ve B2C’de aynı biçimde görüntülenir.' },
          { title: 'Toplam envanter', desc: 'Bu tipin fiziksel oda sayısı — Genel bakış’ın doluluğunun ve RevPAR’ının arkasındaki bölen, bu yüzden KPI’ların doğru okuması için ayarlanması gerekir.' },
        ],
      },
      gallery: {
        title: 'Galeri',
        lead: 'Acentelerin Ara ve Rezervasyon Yap’ta gördüğü ve misafirlerin kuponda gördüğü fotoğraflar.',
        points: [
          { title: 'Tesis ve oda fotoğrafları', desc: 'Tesis düzeyinde ve oda tipi başına yükle; en güçlü görsel önce gelecek şekilde sırala.' },
          { title: 'Mantıklı geri dönüş', desc: 'Kendi fotoğrafı olmayan bir oda tipi tesis galerisine geri döner, böylece bir liste asla görselsiz kalmaz.' },
        ],
      },
      rates: {
        title: 'Ücretler ve takvim',
        lead: 'Her ücret planı için net fiyatı, bir gece veya bütün bir sezon halinde belirle.',
        points: [
          { title: 'Ücret planı bir pakettir', desc: 'Sadece Oda, B&B, İade Edilemez… her biri kendi fiyatlarını taşır ve tesisin satış modunu geçersiz kılabilir. Arama fiyatları daima ücret planı başınadır.' },
          { title: 'Tek gün · aralık · sezon', desc: 'Tek bir gece, bir tarih aralığı veya bütün bir sezonu tek işlemde fiyatlandır. Hafta sonu ve sezon tarihleri renkli bir etiket taşır, böylece desen görünür olur.' },
          { title: 'Satış durdur, silme', desc: 'Bir tarihi satış durdurma ile kapatmak, fiyatını sonrası için korur — kaydetmek için bir ücret değeri gerekir, bu yüzden boş bir küme reddedilir.' },
        ],
        examples: [
          {
            title: 'Net ücretten bir ortağın gördüğü fiyata',
            rows: [
              { label: 'Gece için yüklediğiniz net ücret', value: '1,200,000' },
              { label: '+ Perakende kâr marjı %8 (Kâr Marjı ve Kurallar)', value: '+96,000', accent: 'success' },
              { label: 'Arama / satış fiyatı', value: '1,296,000', strong: true },
            ],
            note: 'Neti burada siz belirlersiniz; satış fiyatı, net artı Retail fiyatlandırma katmanının eklediği her şeydir. Fark, sahip olunan envanterdeki marjınızdır.',
          },
        ],
      },
      allotment: {
        title: 'Kontenjan ve tutmalar',
        lead: 'Gün başına müsait sözleşmeli oda sayısı ve her birinin nasıl tahsis edildiği.',
        points: [
          { title: 'Gün başına dört durum', desc: 'Kontenjan sözleşmeli sayıdır; her gün tutulan (rezerve, ödemesi henüz tahsil edilmemiş), satılan (onaylı) ve satışa açık olarak ayrılır.' },
          { title: 'Toplu belirle', desc: 'Ücretlerin belirlendiği gibi, bir kontenjan sayısını bütün bir tarih aralığında tek işlemde belirle.' },
          { title: 'Anında vs Talep Üzerine', desc: 'Anında satışlar satışa-açığı gerçek zamanlı düşürür, böylece asla fazla satış yapamazsınız; Talep Üzerine satışlar operatör onaylayana kadar kontenjana dokunmaz.' },
        ],
        examples: [
          {
            title: 'Tek bir günün müsaitliği',
            rows: [
              { label: 'Sözleşmeli kontenjan', value: '20' },
              { label: '− Tutulan (tahsil bekliyor)', value: '−3' },
              { label: '− Satılan (onaylı)', value: '−5' },
              { label: 'Satışa açık', value: '12', accent: 'success', strong: true },
            ],
            note: 'Bir Anında rezervasyon bir odayı hemen satışa açıktan → satılana taşır; bir Talep Üzerine rezervasyon, operatör Canlı rezervasyonlar sekmesinde onaylayana kadar dört sayının hiçbirine dokunmaz.',
          },
        ],
      },
      ancillaries: {
        title: 'Yan hizmetler',
        lead: 'Bu tesisin odanın yanında sattığı ekstralar — transferler, kahvaltı, spa, geç çıkış.',
        points: [
          { title: 'Referanstan', desc: 'Her ekstranın kategorisi Yan hizmet tipleri referansından gelir; siz bir fiyat ve bir ücretlendirme temeli belirlersiniz.' },
          { title: 'Ücretlendirme temeli çarpar', desc: 'Rezervasyon başına (bir kez), gece başına (× gece) veya kişi başına (× misafir) — temel, fiyatın bir rezervasyonda nasıl ölçekleneceğine karar verir.' },
          { title: 'Ücretler’de görünür', desc: 'Eklenen ekstralar rezervasyonun Ücretler sekmesinde görünür ve yolcu fiyatına dahil olur.' },
        ],
        examples: [
          {
            title: '3 gecelik, 2 misafirli bir konaklamadaki ekstralar',
            rows: [
              { label: 'Havaalanı transferi · rezervasyon başına 450,000', value: '450,000' },
              { label: 'Kahvaltı · gece başına 250,000 × 3', value: '750,000' },
              { label: 'Rezervasyona eklenen toplam ekstralar', value: '1,200,000', accent: 'accent', strong: true },
            ],
            note: 'Aynı liste fiyatını farklı ölçeklendiren şey ücretlendirme temelidir — rezervasyon başına bir kez alınır, gece başına konaklama süresini izler, kişi başına kişi sayısını izler.',
          },
        ],
      },
      bookings: {
        title: 'Canlı rezervasyonlar',
        lead: 'Bu tesise karşı yapılan her rezervasyon — ve Talep Üzerine konaklamaların onaylandığı yer.',
        points: [
          { title: 'Tam rezervasyon listesi', desc: 'Kimin rezervasyon yaptığını, hangi oda ve ücret planını, tarihleri ve durumu gör.' },
          { title: 'Talep Üzerine’yi Onayla / Reddet', desc: 'Talep Üzerine konaklamalarda karar çubuğu buradadır: Onayla yetkilendirilen ödemeyi tahsil eder ve kontenjanı taahhüt eder; Reddet yetkilendirmeyi iptal eder.' },
          { title: 'SLA içinde', desc: 'Her iki eylem de tesisin Talep Üzerine SLA penceresi içinde (Sözleşme ve ayarlar altında belirlenir) gerçekleşmelidir, aksi halde talep zaman aşımına uğrar.' },
        ],
      },
      settings: {
        title: 'Sözleşme ve ayarlar',
        lead: 'Tedarikçi sözleşmesi artı tesisin nasıl sattığını yöneten operasyonel anahtarlar.',
        points: [
          { title: 'Sözleşme koşulları', desc: 'Tesisin arkasındaki ticari anlaşma — yüklediğiniz net ücretlerin temeli.' },
          { title: 'Satış modu', desc: 'Anında veya SLA saatleri ve rezervasyon son gün süresiyle Talep Üzerine. Ücret planları bunu plan başına geçersiz kılabilir.' },
          { title: 'Kapsam ve durum', desc: 'Platform (acentelere paylaşılmış, onlar için salt okunur) vs Acente (özel), artı tesisin aktif / duraklatılmış durumu.' },
        ],
      },
    },
    related: ['supply-properties', 'reference-data', 'markup'],
  },

  // ── INVENTORY section ───────────────────────────────────────────────────
};
